import React, {useRef} from 'react';
import {OverviewType} from "../../../constant/CodeSpecNum";
import TextViewFileUpdater from "../../../components/files/TextViewFileUpdater";
import CodeEditorPanel from "../fieldMng/shared/CodeEditorPanel";
import CodeOptionTreeEditor from "../fieldMng/shared/CodeOptionTreeEditor";
import {GROUP_CODE_CHILD_LABELS, GROUP_CODE_EDITOR_LABELS} from "./groupCodeLabels";
import {GroupCodeServiceReadExtras} from "./GroupCodeCurrentCodeReadExtras";
import GroupCodeApprovalFields from "./GroupCodeApprovalFields";

function ServiceLevelSelect({label, value, onChange}) {
    const [open, setOpen] = React.useState(false);
    const ref = useRef(null);
    const items = Object.values(OverviewType);
    const selected = value ? OverviewType[value] : null;
    const displayValue = selected ? `${selected.kor} (${selected.scale})` : "";

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (ref.current && !ref.current.contains(event.target)) {
                setOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    return (
        <div className="code-editor__field code-editor__field--inline group-code-inline-select" ref={ref}>
            <label className="code-editor__inline-label">{label}</label>
            <div className="group-code-inline-select__control">
                <button
                    type="button"
                    className={`group-code-inline-select__trigger ${open ? "is-open" : ""}`}
                    onClick={() => setOpen((prev) => !prev)}
                >
                    <span className={`group-code-inline-select__value ${displayValue ? "" : "is-placeholder"}`}>
                        {displayValue || "선택"}
                    </span>
                    <span className="group-code-inline-select__chevron" aria-hidden>▾</span>
                </button>
                {open && (
                    <ul className="group-code-inline-select__menu">
                        {items.map((item) => (
                            <li key={item.value}>
                                <button
                                    type="button"
                                    className="group-code-inline-select__option"
                                    onClick={() => {
                                        onChange(item.value);
                                        setOpen(false);
                                    }}
                                >
                                    {`${item.kor} (${item.scale})`}
                                </button>
                            </li>
                        ))}
                    </ul>
                )}
            </div>
        </div>
    );
}

function GroupCodeServiceEditor({
    code,
    setCode,
    onUpdate,
    onDelete,
    onCreateChild,
    onUpdateChild,
    onDeleteChild,
}) {
    const extraContent = (
        <div className="group-code-service-fields">
            <GroupCodeApprovalFields
                code={code}
                showAfter={false}
            />

            <ServiceLevelSelect
                label="목표수준"
                value={code.targetLevel}
                onChange={(value) => setCode((prev) => ({...prev, targetLevel: value}))}
            />
            <ServiceLevelSelect
                label="최소수준"
                value={code.minimumLevel}
                onChange={(value) => setCode((prev) => ({...prev, minimumLevel: value}))}
            />

            <TextViewFileUpdater
                nativeInput
                inline
                uploadLabel="파일업로드"
                tableInfo={{tableName: "service_code", joinKey: code.id}}
            />
        </div>
    );

    const readExtraContent = <GroupCodeServiceReadExtras code={code} />;

    return (
        <div className="common-code-editor">
            <div className="common-code-editor__info">
                <CodeEditorPanel
                    category="groupCode"
                    item={code}
                    setItem={setCode}
                    onSave={onUpdate}
                    onDelete={onDelete}
                    nameLabel="서비스코드명"
                    saveLabel="저장"
                    sectionTitle={GROUP_CODE_EDITOR_LABELS.sectionTitle}
                    deleteTitle={GROUP_CODE_EDITOR_LABELS.deleteTitle}
                    deleteDescription={GROUP_CODE_EDITOR_LABELS.deleteDescription}
                    viewMode
                    extraContent={extraContent}
                    readExtraContent={readExtraContent}
                />
            </div>
            <div className="common-code-editor__options">
                <CodeOptionTreeEditor
                    parentId={code.id}
                    options={code.children ?? []}
                    onCreate={onCreateChild}
                    onUpdate={onUpdateChild}
                    onDelete={onDeleteChild}
                    labels={GROUP_CODE_CHILD_LABELS}
                />
            </div>
        </div>
    );
}

export default GroupCodeServiceEditor;
